import type { ReactNode } from 'react'
import * as RadixDialog from '@radix-ui/react-dialog'

// Controlled modal (open driven by state, not a trigger click) — for cases like the
// one-time API key reveal, opened programmatically right after a create call succeeds.
// See ConfirmDialog.tsx for the trigger-based confirm/destructive-action variant.
export function Dialog({
  open,
  onOpenChange,
  title,
  children,
}: {
  open: boolean
  onOpenChange: (open: boolean) => void
  title: string
  children: ReactNode
}) {
  return (
    <RadixDialog.Root open={open} onOpenChange={onOpenChange}>
      <RadixDialog.Portal>
        <RadixDialog.Overlay className="fixed inset-0 z-20 bg-black/60" />
        <RadixDialog.Content className="fixed left-1/2 top-1/2 z-30 w-[calc(100%-2rem)] max-w-md -translate-x-1/2 -translate-y-1/2 rounded-xl border border-line bg-card p-5 shadow-xl focus:outline-none">
          <RadixDialog.Title className="mb-2 text-sm font-semibold text-ink">{title}</RadixDialog.Title>
          {children}
        </RadixDialog.Content>
      </RadixDialog.Portal>
    </RadixDialog.Root>
  )
}
